export default __webpack_public_path__ + "static/media/le_croise15.ca5416ca.jpg";